import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const BranchAddEdit = ({
  list,
  setList,
  bankList,
  selectedBankId,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [swiftCode, setSwiftCode] = useState('');
  const [routingNumber, setRoutingNumber] = useState('');
  const [status, setStatus] = useState(false);

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);
  // const [bankList, setBankList] = useState([]);
  const [bankId, setBankId] = useState('');

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;
    if (!bankId.trim()) {
      console.log('bankId');
      handleSnakbarOpen('Please select bank name', 'error');
      document.getElementById('bankId').focus();
      return (isError = true);
    }
    if (!name.trim()) {
      handleSnakbarOpen('Please enter branch name', 'error');
      document.getElementById('name').focus();
      return (isError = true);
    }
    if (!swiftCode.trim()) {
      console.log('swiftCode');
      handleSnakbarOpen('Please enter swift Code', 'error');
      document.getElementById('swiftCode').focus();
      return (isError = true);
    }
    if (!routingNumber.trim()) {
      console.log('routingNumber');
      handleSnakbarOpen('Please enter routing number', 'error');
      document.getElementById('routingNumber').focus();
      return (isError = true);
    }

    console.log('finish');
    return isError;
  };
  const handleChange = event => {
    setBankId(event.target.value);
  };

  const clearStates = () => {
    setId('');
    setBankId('');
    setName('');
    setSwiftCode('');
    setRoutingNumber('');
    setStatus(false);
    setEditObj({});
  };

  const onSubmit = async e => {
    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      try {
        if (addForm) {
          console.log('asdfasdfasdf');
          response = await axios({
            url: `/api/v1/private/bank/${bankId}/branch`,
            method: 'post',
            data: { name, swiftCode, routingNumber, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('selectedBankId.lenght', selectedBankId.lenght);
          if (selectedBankId === bankId) {
            setList([...list, response.data.data]);
          }
          clearStates();
          console.log('addForm Submit', name, swiftCode, routingNumber, status);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/bank/${selectedBankId}/branch/${id}`,
            method: 'put',
            data: { name, swiftCode, routingNumber, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
          console.log('editForm Submit', id, name, swiftCode, routingNumber, status);
        }
        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    if (editObj.id) {
      console.log('editObj', editObj);
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setName(editObj.name);
      setSwiftCode(editObj.swiftCode);
      setRoutingNumber(editObj.routingNumber);

      setStatus(editObj.status);
    }
  }, [editObj]);
  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Branch' : 'Add Branch'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Branch' : 'Add Branch'}
        </Typography>
      </div>

      {addForm && (
        <FormControl variant="outlined" size="small" fullWidth className={`${classes.marginStyle} ${classes.selectStyle}`}>
          <InputLabel id="demo-simple-select-outlined-label">Select Bank</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="bankId"
            value={bankId}
            onChange={handleChange}
            label="Select Bank">
            {bankList &&
              bankList.map((item, i) => (
                <MenuItem value={item.id} key={i}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
      <TextField
        id="name"
        label="Branch Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <TextField
        id="swiftCode"
        label="Swift Code"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={swiftCode}
        onChange={e => setSwiftCode(e.target.value)}
      />
      <TextField
        id="routingNumber"
        label="Routing Number"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={routingNumber}
        onChange={e => setRoutingNumber(e.target.value)}
      />

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default BranchAddEdit;
